import React from 'react'
import PageTitle from '@components/Common/PageTitle';
import HeaderComponent from '@components/VerticalLayout/HeaderComponent';
import { CardBody, Container } from "reactstrap";
import { useTranslation } from "react-i18next";
import BreadcrumbOptions from "./BreadcrumbOptions";


function AdyenTransactionsOverview() {
  const { t } = useTranslation();

  const holderAccountId = localStorage.getItem("holderAccountId");
  return (
    <React.Fragment>
    <PageTitle title="Transactions SoftaveraPay" />
    <div className="">
      <BreadcrumbOptions
        currentLink={[
          {
            item: t("SOFTAVERAPAY"),
            link: `${process.env.REACT_APP_PORTAIL_API}`,
          },
          {
            item: t(`${"Rapports"}`),
            link: `${"Transactions"}`,
          },
          {
            item: t(`${"Transactions"}`),
            link: `${"Transactions"}`,
          },
        ]}
      />
      <Container fluid>
        <HeaderComponent
          title={t(
            `The 'Transactions' report presents the transactions made for a balance account over a defined period, including details such as the date, payment method, transaction type, and amount.`
          )}
        />

        <CardBody
          style={{
            padding: "1px",
          }}
        >
          <div
            style={{
              width: "100%",
              marginTop: "10px",
              height: "618px",
            }}
          >
            <div style={{ width: "100%", height: "100%" }}>
              {" "}
              <iframe
                src={`${process.env.REACT_APP_SOFTAVERAPAY}?accountHolder=${holderAccountId}&role=transactions`}
                // src={`http://192.168.2.63:8082?accountHolder=${holderAccountId}&role=transactions`}
                width="100%"
                height="100%"
                title="Embedded URL"
              />
            </div>
          </div>
        </CardBody>
      </Container>
    </div>
  </React.Fragment>
  )
}

export default AdyenTransactionsOverview
